// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2UxM7","row":"ProcedureTreatmentSummary_row__2_lq0"};